import React from "react";
import classNames from "classnames";
import { NumericFormat } from "react-number-format";

const Currency: React.FC<{
  value: number;
  className?: any;
  showDecimal?: boolean;
}> = ({ value = 0, className, showDecimal = false }) => (
  <NumericFormat
    className={classNames("", className)}
    value={value}
    displayType={"text"}
    decimalScale={showDecimal ? 2 : 0}
    thousandSeparator="."
    decimalSeparator=","
    prefix={"$"}
  />
);

export default Currency;
